module.exports = __webpack_public_path__ + "static/media/dortua.aa8b93b3.jpeg";